import React, { Component } from 'react';
import { Link } from "react-router-dom";
import './Nav.css';

export default class Nav extends Component {

  logOut(index, myId)
  {
   let url;
   if(window.location.hostname === 'localhost'){
       url = 'http://127.0.0.1:3030/logout'
    }else{
      url = 'http://trainer.activepipe.com:3030/logout'
    }

    fetch(url, {
      method: 'POST',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: JSON.parse(localStorage.userData).id
      })
    })
    .then((response) => response.json())
    .then((responseJson) =>
    {

    }).catch((error) => {
        console.log("Error");
        console.error(error);
    });

    localStorage.removeItem("userData");
    window.location.href = '/login'

  }

  render() {
    return (
        <nav>
            <div className={"top"}>
              <Link to="/" className={"icon"} data-text="All Modules"><img src={'../assets/images/icons/list.svg'} alt="Modules"/>
              </Link>
              <a href="/build" className={"icon"} data-text="New Module"><img src={'../assets/images/icons/plus.svg'} alt="Create New Module"/></a>
            </div>
            <div className={"bottom"}>
              <div onClick={()=>this.logOut()} className={"logout icon"} data-text="Log Out" title="Logout"><img src={'../assets/images/icons/power.svg'} alt="logout"/></div>
            </div>
        </nav>
    );
  }
}


// WEBPACK FOOTER //
// ./src/views/Nav/Nav.js